import styled from 'styled-components';

//helpers
import {truncate} from 'styles/partials';
import {borderRadius, cardShadowCss} from 'styles/vars';

//components
import CloudinaryPicture from 'components/CloudinaryPicture';
import {HeadingDesktop, HeadingMobile} from 'components/Heading';
import Icon from 'components/Icon';

export const ResultRow = styled.a.attrs({
  'data-cy': 'result-card'
})`
  align-items: center;
  background: #fff;
  display: flex;
  padding: 0.5rem;
  text-decoration: none; // for mobile

  ${p =>
    p.device === 'desktop' &&
    `
    ${cardShadowCss(p.shouldShowShadowOnHover)}
    border-radius: ${borderRadius.desktop}px;
  `}
`;

export const StyledCloudinaryPicture = styled(CloudinaryPicture).attrs({
  aspectRatio: 4 / 3,
  sizes: '84px'
})`
  flex-shrink: 0;
  width: 84px;
`;

export const StyledHeadingDesktop = styled(HeadingDesktop)`
  display: flex;
  white-space: nowrap;

  > b {
    ${truncate};
    margin-right: 0.3em;
  }
`;

export const StyledHeadingMobile = StyledHeadingDesktop.withComponent(HeadingMobile);

export const ContentWrapper = styled.div`
  flex-grow: 1;
  margin: 0 1rem;
  overflow: hidden;
`;

export const Chevron = styled(Icon).attrs({
  name: 'chevron-right'
})`
  display: block;
  flex-shrink: 0;
  margin-left: 1rem;
  opacity: 0.2;
`;
